const convertToyyyyMMdd = (value) => {
  // If value is not valid date, return empty string
  if (!Date.parse(value)) return "";

  // Format the date to YYYY-MM-DD
  const dateTime = new Date(value);
  const year = dateTime.getFullYear();
  const month = String(dateTime.getMonth() + 1).padStart(2, "0");
  const day = String(dateTime.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export default convertToyyyyMMdd;
